export default __webpack_public_path__ + "static/media/postcss.ca045bac.svg";